var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57143 8C4.57143 5.26488 6.78868 3.04762 9.52381 3.04762C12.2589 3.04762 14.4762 5.26488 14.4762 8C14.4762 10.7351 12.2589 12.9524 9.52381 12.9524V16C13.9421 16 17.5238 12.4183 17.5238 8C17.5238 3.58172 13.9421 0 9.52381 0C5.10553 0 1.52381 3.58172 1.52381 8V8.38095H0L3.04762 11.4286L6.09524 8.38095H4.57143V8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/Replay.35097555.svg";
export { ForwardRef as ReactComponent };